import * as React from 'react';
import ErrorDisplay from '../components/discovery/error_display';

const SelectableCreditCardListError: React.StatelessComponent<{}> = () => {
  return (
    <div className="site-wrapper site-wrapper--narrow ptb-2">
      <ErrorDisplay />
    </div>
  );
};

export default SelectableCreditCardListError;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/selectable_credit_card_list_error.tsx